import { get, post } from "Service";
import { sendMessage } from "./signalRService";

const fetchChatHistoryByCaseId = (payload: any) => {
  const request = {
    subUrl: `${payload.caseId}/messages`,
    isChat: true,
  };
  return get(request);
};

const handleUploadVoice = async (payload: {
  audioBlob: Blob;
  caseId: number | null;
  senderUserId: number | null;
}) => {
  const { audioBlob, caseId, senderUserId } = payload;
  const formData = new FormData();

  if (caseId) formData.append("caseId", caseId.toString());
  // if (senderUserId) formData.append("senderUserId", senderUserId.toString());
  formData.append("file", audioBlob, "voiceMessage.webm");

  const request = {
    subUrl: `Attachments/upload`, // adjust to match your backend route
    data: formData,
    dataType: "form-data",
  };

  return post(request); // return directly like `uploadAttachment`
};

const uploadAttachment = async (payload: {
  attachmentBlob: Blob;
  caseId: number | null;
}) => {
  const { attachmentBlob, caseId } = payload;
  const formData = new FormData();
  formData.append("file", attachmentBlob);
  if (caseId) {
    formData.append("caseId", caseId?.toString());
  }

  const request = {
    subUrl: `Attachments/upload`,
    data: formData,
    dataType: "form-data",
  };
  return post(request);
};

const markMessagesAsRead = async (payload: { caseId: number }) => {
  const request = {
    subUrl: `${payload.caseId}/mark-read`,
    isChat: true,
  };
  return post(request);
};

const ChatApi = {
  fetchChatHistoryByCaseId,
  handleUploadVoice,
  uploadAttachment,
  markMessagesAsRead,
};

export default ChatApi;
